import { Children, type ReactNode } from 'react';

import { isSlot } from '../../../core/utils/is-slot.js';
import { Nodes } from '../slots/Nodes.js';
import type { SankeyChartNodesProps } from '../types/sankey-props.js';

/** Slot configuration collected from the `SankeyChart` children. */
export interface SankeyChartSlots {
  nodes: SankeyChartNodesProps;
}

/**
 * Collects the `SankeyChart` slot configurations in a single pass over the
 * children.
 * @param children - the `SankeyChart` children
 * @returns the collected slot configuration
 */
export const iterateSlots = (children: ReactNode): SankeyChartSlots => {
  const slots: SankeyChartSlots = { nodes: {} };

  Children.forEach(children, (child) => {
    if (isSlot(child, Nodes)) {
      slots.nodes = child.props;
    }
  });

  return slots;
};
